import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class invitationLetter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Invitation Letter
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="InvitationLetter_section">
                        <div className="container">
                            <div className="row">
                                <div
                                    className="col-lg-12 col-sm-12"
                                    data-aos="fade-right"
                                    data-aos-delay={300}
                                >
                                    <div className="about-content">
                                        {/* <h4 class="border_title">Invitation</h4> */}
                                        <div className="selector">
                                            <h2 className="ah-headline letters rotate-3">
                                                {/* <p>Conference Organisation</p> */}
                                                <span className="position_relative">INVITATION LETTER</span>
                                            </h2>
                                        </div>
                                        {/*  <p>Established as a non profit Industry body in 1980, today is the back bone of Textile Engineering Industry & the best Catalyst of Technological Excellence, weaving success story for Textiles & Textile Engineering Industry, not only in India but across the globe.</p>
                      <p>India ITME is unique in its kind of Exhibitions, as it strengthens the industry by escalating Textile Manufacturing, supporting in building avant-garde manufacturing infrastructure by Technology up gradation, fostering Innovation, facilitating Exchange of Knowledge and encouraging Foreign Direct Investments & Joint Ventures, without compromising on enhancing skills and traditional strengths of the hand-woven sector.</p>
                      <p>Achieving an enviable growth of 54% from 2012 onwards, India ITME Society is continuing its growth trajectory to reach the top slot. Today the events by India ITME Society are globally acknowledged, by not only the Textile & Textile Engineering Industry, but also has become a landmark event & pride for India.</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 position_relative">
                                    <div
                                        className="chairman_msg_css"
                                        data-aos="fade-up"
                                        data-aos-delay={200}
                                    >
                                        <div className="chairman_img">
                                            <img src="assets/img/chairman.jpg" />
                                            <h2 className="name">Ketan Sanghvi</h2>
                                            <p className="position">Chairman</p>
                                            <p className="position">India ITME Society</p>
                                        </div>
                                    </div>
                                    <div className="chairman_content">
                                        <p className="message">
                                            Greetings and Good wishes from India ITME Society!
                                        </p>
                                        <p className="message">
                                            With great pleasure I share with you that, “India ITME Society”
                                            shall host 12th edition of India ITME from 04th to 9th December
                                            2026 at India Exposition Mart Ltd, (IEML) Greater Noida.
                                        </p>
                                        <p className="message">
                                            India ITME Society has strived to spearhead innovative
                                            technologies for textiles not only in India but also in the
                                            neighbouring countries. It is exciting that this pivotal business
                                            event has established its trust among the industry members and has
                                            proven beyond doubt, its commitment towards industry growth and
                                            business prosperity.
                                        </p>
                                        <p className="message">
                                            Having grown from strength to strength, India ITME 2026 shall see
                                            the largest of India ITME series and shall be held in the State of
                                            Art exhibition facility IEML at Greater Noida. The venue is easily
                                            accessible from nation’s capital, Delhi.
                                        </p>
                                        <p className="message">
                                            We hope and strive to provide a spectacular event which shall also
                                            coincide with the completion of 40 years of the Society. As an
                                            event organiser, India ITME Society has become globally trusted
                                            name for quality and excellence and has successfully served the
                                            industry with commitment.
                                        </p>
                                        <p className="message">
                                            It is my pleasure and privilege to invite you to join us at India
                                            ITME 2026 to celebrate the soul of textiles.
                                        </p>
                                        <p className="message">
                                            Look forward to welcoming you at India ITME 2026.
                                        </p>
                                        <br />
                                        <p className="message mb_0">With Best Regards,</p>
                                        <p className="message mb_0">Ketan Sanghvi</p>
                                        <p className="message last_para">Chairman , INDIA ITME SOCIETY</p>
                                        {/* <p class="message last_para">With great pleasure I share with you that, “India ITME Society” shall host 11th edition of India ITME from 08th to 13th December 2022 at India Exposition Mart Ltd, (IEML) Greater Noida.</p> */}
                                        <a
                                            href="javascript:void(0)"
                                            className="read_more_btn register_click"
                                        >
                                            REGISTER NOW
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(invitationLetter));